// There are multiple layers here but the purpose of this composible is essentially to 
// fetch content which is used across the site and save it in stores so that its ready to go, 

// maybe the app can have a checklist in the content store and when the app loads it gracefully initialise the stores
// the content store holds small collections which are used for things like blog carousels etc, with a light overview, 
// when the fully content is required a specific call is made for it, this is a convenience process. 



export function useGlobalContent() {

  // Settings
  const initOnLoad = ref(true);
  
  const { $content } = useNuxtApp();

  const loading = ref(false);
  const parsedContent = ref(null);
  const route = useRoute();

  const routeName = computed(() => route.name)
  

 

  // async function fetchProductData(slug) {
  //   loading.value = true
  //   try {
  //     const { data } = await useAsyncData(`blog-${slug}`, () => queryCollection('blogs').
  //     where('slug', '=', slug).first())
  //     parsedContent.value = data.value
  //     updateHeader()
  //   } catch (error) {
  //     console.error('Failed to fetch product data:', error)
  //   } finally {
  //     loading.value = false
  //   }
  // }

  const data = ref();

  async function initBlogs() {
    try {
      // const { data } = await useAsyncData(`blog-${slug}`, () => queryCollection('blogs').
      // where('slug', '=', slug).first())
      // parsedContent.value = data.value
      // updateHeader()

      console.log("initBlogs")

      const $post = $content.content.blog
      $post.init = false
      $post.working = true
      $post.total = await queryCollection('blogs').count()
      $post.batchSize = 8

      console.log("initBlogs total", $post.total)

      if($post.total > 0) {
        const records = await queryCollection('blogs')
          .limit($post.batchSize)
          .order('date', 'ASC')
          .select(
            'title', 
            'slug',
            'date',
            'description', 
            'excerpt',
            'tags',
            'image',
            'cardImgObjPosition'
          ).all()

        if(records.length > 0) {
          $post.init = true
          $post.working = false
          $post.records = records as ContentBlog
        } else {
          $post.init = false
          $post.working = false
          $post.error = true
          $post.errorMsg = "No blogs found"
        }

        // console.log("initBlogs records", $post.records)

      } else {
        $post.init = false
        $post.working = false
        $post.error = true
        $post.errorMsg = "No blogs found"
      }
      
      
    } catch (error: any) {
      console.error('Failed to fetch blog content:', error.message)
    } finally {
      loading.value = false
    }
  }


  async function initProducts() {


    try {
      // const { data } = await useAsyncData(`blog-${slug}`, () => queryCollection('blogs').
      // where('slug', '=', slug).first())
      // parsedContent.value = data.value
      // updateHeader()

      const $post = $content.content.product
      $post.init = false
      $post.working = true
      $post.total = await queryCollection('products').count()
      $post.batchSize = 100

      if($post.total > 0) {
        const records = await queryCollection('products')
          .where('active', '=', true)
          .limit($post.batchSize)
          .order('title', 'ASC')
          .select(
            'titles', 
            'description',
            'image',
            'category', 
            'slug',
            'origin',
            'denaturation',
            'images'
          ).all()


        if(records.length > 0) {
          $post.init = true
          $post.working = false
          $post.records = records as ContentProduct
        } else {
          $post.init = false
          $post.working = false
          $post.error = true
          $post.errorMsg = "No Products found"
        }

      } else {
        $post.init = false
        $post.working = false
        $post.error = true
        $post.errorMsg = "No Products found"
      }
      
      
    } catch (error: any) {
      console.error('Failed to fetch blog content:', error.message)
    } finally {
      loading.value = false
    }
  }

  async function initSDS() {
    try {
      const $sds = $content.content.sds;
      $sds.init = false;
      $sds.working = true;
      
      // Query for products that are active and have a non-empty 'msds' field
      $sds.total = await queryCollection('products')
        .where('active', '=', true)
        .andWhere(query => query.where('msds', 'IS NOT NULL'))
        .count();

      
      $sds.limit = 100; // Adjust as needed
  
      if ($sds.total > 0) {

        const records = await queryCollection('products')
          .where('active', '=', true)
          .andWhere(query => query.where('msds', 'IS NOT NULL'))
          .limit($sds.limit)
          .order('title', 'ASC')
          .select(
            'title', 
            'slug',
            'description',
            'msds',
            'origin',
            'denaturation',
            'category',
            'subCategory'
          )
          .all();

          console.log("initSDS records", records)
  
        if (records.length > 0) {
          // Map the records to our ContentSDS shape.
          // Depending on your MD file structure, you might choose titles.card or titles.friendly for the title.
          $sds.records = records.map((record: any) => ({
            title: record.titles?.card || record.title,
            description: record.description?.short || "",
            slug: record.slug,
            origin: record.origin,
            denaturation: record.denaturation,
            msds: record.msds,
            category: record.category,
            subCategory: record.subCategory,
          }));
          $sds.init = true;
        } else {
          $sds.error = true;
          $sds.errorMsg = "No SDS products found";
        }
      } else {
        $sds.error = true;
        $sds.errorMsg = "No SDS products found";
      }
    } catch (error: any) {
      console.error('Failed to fetch SDS products:', error.message);
    } finally {
      loading.value = false;
    }
  }

  async function init() {
    initBlogs();
    initProducts();
  }

  // The starting point
  watch(routeName, (name) => {

    console.log("init routeName", name)

    nextTick(() => {
      if(initOnLoad.value) {
        data.value = ""
        init()

        if(name === "sds") {
          initSDS()
        }
      }
    })
  }, {
    immediate: true
  })

  return {
    init,
    data
  }

}